import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { Model } from "../types";
import {
	getModelsAsync,
	GetModelsAsyncPayload,
	setModels,
	getModelDetailAsync,
	GetModelDetailPayload,
	setModel,
	CreateModelPayload,
	createNewModelAsync,
	updateModelAsync,
	UpdateModelPayload,
} from "./model.slice";

// Get list
function* getModelsSaga(action: PayloadAction<GetModelsAsyncPayload>) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		const { take } = query;
		let { skip } = query;
		skip = skip * take;
		try {
			const { data: response } = await api.get<ApiResponse<Model[]>>("/dashboard/car-models", { ...query, skip });
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setModels.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetModels() {
	yield takeLatest(getModelsAsync, getModelsSaga);
}

// Get model detail
function* getModelDetailSaga(action: PayloadAction<GetModelDetailPayload>) {
	const { id } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Model>>(
				`/dashboard/car-models/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setModel.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetModelDetail() {
	yield takeLatest(getModelDetailAsync, getModelDetailSaga);
}

// Create new model
function* createNewModelSaga(action: PayloadAction<CreateModelPayload>) {
	const { data, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post("/dashboard/car-models", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create successful"));
		callback();
	} else {
		message.error(translate(error.message));
	}
}

function* watchCreateModel() {
	yield takeLatest(createNewModelAsync, createNewModelSaga);
}
// Create new model
function* updateModelSaga(action: PayloadAction<UpdateModelPayload>) {
	const { data, id, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.put(`/dashboard/car-models/${id}`, data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Update successful"));
		if(callback) callback();
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateModel() {
	yield takeLatest(updateModelAsync, updateModelSaga);
}


const modelSaga = [
	watchGetModels(), 
	watchGetModelDetail(),
	watchCreateModel(),
	watchUpdateModel()
];
export default modelSaga;
